
import { CurrencyIcon } from "lucide-react";
import { create } from "zustand";

export const useExamStore = create((set) => ({
  questionIds: null,
  setQuestionIds: (ids) => set({ questionIds: ids }),
  userResponses: [],
  setUserResponses: (responses) => set({ userResponses: responses }),
  analysisResponse: null,
  setAnalysisResponse: (response) => set({ analysisResponse: response }),
  currentOMR: null,
  setCurrentOMR: (response) => set({ currentOMR: response })

}))
